/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Form, Input, Button, Flex, message, Badge, Card, Select } from "antd";
import { Row, Col, Space } from "antd";
import { SaveFilled } from "@ant-design/icons";
import { ButtonBack } from "../../../components/button";
import { useLocation, useNavigate } from "react-router";
import { delay } from "../../../utils/util";
// import OptionService from '../../service/Options.service';
import Runcodeservice from "../../../service/ERP/Runcode.service";

const runcodeservice = Runcodeservice();
// const opservice = OptionService();
const from = "/ERP/runcode";
const RuncodeManage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { config } = location.state || { config: null };
  const [form] = Form.useForm();

  const [formDetail, setFormDetail] = useState({});

  /* โหมดดูอย่างเดียว — ปิดการแก้ไขทั้งฟอร์ม หน่อนปุ่มบันทึก */
  const isView = config?.action === "view";

  // const [packageTypeOption, setPackageTypeOption] = useState([]);

  useEffect(() => {
    // setLoading(true);
    if (config?.action !== "create") {
      getsupData(config.code);
    }
    // console.log(config);

    return () => {
      form.resetFields();
    };
  }, []);
  const getsupData = (v) => {
    runcodeservice
      .get(v)
      .then(async (res) => {
        const { data } = res.data;

        const init = {
          ...data,
        };

        setFormDetail(init);
        form.setFieldsValue({ ...init });
      })
      .catch((err) => {
        console.log(err);
        message.error("Error getting infomation Product.");
      });
  };

  const handleConfirm = () => {
    form.validateFields().then((v) => {
      const source = { ...formDetail, ...v };
      const actions =
        config?.action !== "create"
          ? runcodeservice.update(source)
          : runcodeservice.create(source);

      actions
        .then(async (r) => {
          message.success("Request success.");
          navigate(from, { replace: true });
          await delay(300);
          console.clear();
        })
        .catch((err) => {
          console.warn(err);
          const data = err?.response?.data;
          message.error(data?.message || "บันทึกไม่สำเร็จ");
        });
    });
  };

  const Detail = (
    <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
      <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
        <Form.Item
          label="Prefix"
          name="prefix"
          rules={[{ required: true, message: "โปรดกรอกข้อมูล" }]}
        >
          <Input placeholder="Prefix" />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
        <Form.Item
          label="เลขที่ถัดจากตัวอักษร"
          name="run_number"
          rules={[{ required: true, message: "โปรดกรอกข้อมูล" }]}
        >
          <Input placeholder="เลขที่ถัดจากตัวอักษร" />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
        <Form.Item
          label="ใช้กับระบบ"
          name="doc_sys"
          rules={[{ required: true, message: "โปรดกรอกข้อมูล" }]}
        >
          <Select
          size="large"
            options={[
              { value: "PK", label: "Packaging" },
              { value: "PC", label: "Packing" },
              { value: "WI", label: "Work Instruction" },
              { value: "FG", label: "Finished Goods" },
              { value: "PG", label: "Packing Goods" },
              { value: "IG", label: "Ingredient" },
              { value: "RM", label: "Raw Material" },
            ]}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
        <Form.Item
          label="คำนิยาม"
          name="definition"
        >
          <Input placeholder="คำนิยาม" />
        </Form.Item>
      </Col>
      
      <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
        <Form.Item name="id">
          <Input type="hidden" disabled />
        </Form.Item>
      </Col>
    </Row>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {!isView && (
            <Button
              icon={<SaveFilled style={{ fontSize: "1rem" }} />}
              type="primary"
              style={{ width: "9.5rem" }}
              onClick={() => {
                handleConfirm();
              }}
            >
              บันทึก
            </Button>
          )}
        </Flex>
      </Col>
    </Row>
  );

  return (
    <div className="runcode-manage xs:px-0 sm:px-0 md:px-8 lg:px-8">
      <Space direction="vertical" className="flex gap-2">
        <Form form={form} layout="vertical" autoComplete="off" disabled={isView}>
          <Card title={config?.title}>{Detail}</Card>
        </Form>
        {SectionBottom}
      </Space>
    </div>
  );
};

export default RuncodeManage;
